// Edit-approval workflow for submitted documents: a reviewer rejects pending
// edit requests. Opened by the `rejectEditRequest` row action
// (rowActionConfig, actionType "modal", allowMultiple) on the edit-request
// queue, so one popup serves a single row and a bulk selection — the one
// mandatory reason typed here is recorded on every selected request.
export const config = {
  title: 'Reject Edit Request',
  okText: 'Reject',
  cancelText: 'Cancel',
  okButtonDanger: true,
  width: 480,
  successMessage: 'Edit request rejected successfully.',
  fields: [
    {
      name: 'rejectionReason',
      label: 'Rejection Reason',
      type: 'textarea',
      required: true,
      rows: 4,
      maxLength: 1000,
      placeholder: 'Explain why this edit request is being rejected',
    },
  ],
};
